import FormControl from '@mui/material/FormControl';
import Text from '../../../../../components/Text';
import styles from '../../styles';

const StepsHeadline = () => (
  <FormControl sx={styles.headlineText} variant='standard'>
    <Text variant='h3' color='primary'>
      Crie sua conta agora!
    </Text>
    <Text variant='hintText'>
      30 dias grátis para você testar, cancele quando quiser.
    </Text>
  </FormControl>
);

export default StepsHeadline;
